import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdvorLinkComponent } from '@sdvor/shared/ui';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { UrlModule } from '@spartacus/core';
import { SdvorOrderConfirmationInfoBodyComponent } from './order-confirmation-info-body/order-confirmation-info-body.component';
import { SdvorOrderConfirmationInfoButtonsComponent } from './order-confirmation-info-buttons/order-confirmation-info-buttons.component';
import { SdvorOrderConfirmationInfoInvoiceButtonComponent } from './order-confirmation-info-invoice-button/order-confirmation-info-invoice-button.component';
import { SdvorOrderConfirmationInfoTitleComponent } from './order-confirmation-info-title/order-confirmation-info-title.component';

@NgModule({
  declarations: [
    SdvorOrderConfirmationInfoTitleComponent,
    SdvorOrderConfirmationInfoBodyComponent,
    SdvorOrderConfirmationInfoButtonsComponent,
    SdvorOrderConfirmationInfoInvoiceButtonComponent,
  ],
  exports: [
    SdvorOrderConfirmationInfoTitleComponent,
    SdvorOrderConfirmationInfoBodyComponent,
    SdvorOrderConfirmationInfoButtonsComponent,
    SdvorOrderConfirmationInfoInvoiceButtonComponent,
  ],
  imports: [NgIf, AsyncPipe, NgClass, UrlModule, RouterLink, SdvorLinkComponent, SdvorButtonComponent],
})
export class SdvorOrderConfirmationInfoModule {}
